import {cloneDeep, forEach, isEmpty} from 'lodash';

const PROPERTY_TYPE_DATA_TYPE = 'dataType';
const PROPERTY_TYPE_NAME = 'name';
const PROPERTY_TYPE_SORT_PARAMETER = 'sortParameter';

const PROPERTY_TYPES_EMBEDDED = '_embedded';
const PROPERTY_TYPES_PROPERTY_TYPES = 'propertytypes';

export class PropertyType {
  constructor(rawData = {}) {
    this.rawData = {...rawData};
  }

  clone() {
    return Object.assign(new PropertyType(cloneDeep(this.rawData)), this);
  }

  getName() {
    return this.rawData[PROPERTY_TYPE_NAME];
  }

  getRawData() {
    return this.rawData;
  }

  getDataType() {
    return this.rawData[PROPERTY_TYPE_DATA_TYPE];
  }

  getSortParameter() {
    return this.rawData[PROPERTY_TYPE_SORT_PARAMETER];
  }
}

export class PropertyTypesConfig {
  static initPropertyTypes(rawDocumentProperties) {
    const propertyTypes = [];
    if (rawDocumentProperties) {
      forEach(rawDocumentProperties, (property) => {
        propertyTypes.push(new PropertyType(property));
      });
    }
    return propertyTypes;
  }

  static initPropertyTypesMap(propertyTypes) {
    const result = {};

    forEach(propertyTypes, (property) => {
      result[property.getName()] = property;
    });
    return result;
  }

  constructor(rawData = {}) {
    this.rawData = {...rawData};
    this.propertyTypes = [];
    this.propertyTypesMap = {};
    this.loaded = false;
    if (!isEmpty(this.rawData)) {
      const rawConfiguration = this.rawData[PROPERTY_TYPES_EMBEDDED];
      if (rawConfiguration && rawConfiguration[PROPERTY_TYPES_PROPERTY_TYPES]) {
        this.propertyTypes = PropertyTypesConfig.initPropertyTypes(
          rawConfiguration[PROPERTY_TYPES_PROPERTY_TYPES]
        );
        this.propertyTypesMap = PropertyTypesConfig.initPropertyTypesMap(
          this.propertyTypes
        );
      }
      this.loaded = true;
    }
  }

  getPropertyTypes() {
    return this.propertyTypes;
  }

  getPropertyTypesMap() {
    return this.propertyTypesMap;
  }

  getPropertyType(propertyName) {
    return this.propertyTypesMap[propertyName];
  }

  isLoaded() {
    return this.loaded;
  }
}

export default {PropertyTypesConfig, PropertyType};
